module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radioBtn"
  }, [(_vm.value) ? _c('img', {
    attrs: {
      "src": require("../assets/svg/conCircle.svg")
    },
    on: {
      "click": _vm.clickHandler
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/svg/circle.svg")
    },
    on: {
      "click": _vm.clickHandler
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e3e3c70!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/radioBtn.vue
// module id = 1516
// module chunks = 18